import { render, staticRenderFns } from "./PreviewModal.vue?vue&type=template&id=2507a060&"
import script from "./PreviewModal.vue?vue&type=script&lang=js&"
export * from "./PreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewModal.vue?vue&type=style&index=0&id=2507a060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports